<template>
    <div
        class="form-hall"
        :class="{invalid: invalid || error}"
    >
        <div
            v-if="!loading"
            class="form-hall-current"

        >
            <div v-if="currentHall">
                <div class="form-hall-name">
                    {{ currentHall.name }}
                </div>
                <div class="form-hall-address">
                    {{ currentHall.address }};
                    {{ currentHall.postCode }}
                    {{ currentHall.city }}
                </div>
            </div>
            <button
                class="form-hall-button"
                @click.prevent="open"
                :disabled="disabled"
            >
                Zmień
            </button>
        </div>


        <Loader v-if="loading" :is-active="loading" />

        <div v-if="error" class="error">
            Błąd pobierania listy hal
        </div>

        <FormHallList
            :items="items"
            :selected="currentHallId"
            ref="halls"
            @select="onSelect"
        />
    </div>
</template>

<script>
    import Loader from '@/components/loader/Loader'
    import ApiMakro from '@/api/ApiMakro'
    import FormHallList from '@/components/form/FormHallList'
    export default {
        name: "FormHall",
        components: {FormHallList, Loader},
        props: {
            value: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                loading: true,
                error: false,
                currentHallId: null,
                items: []
            }
        },
        mounted() {
            this.getHallsFromApi()
        },
        computed: {
            currentHall () {
                console.log('current hall')
                if (!this.items) {
                    return {}
                }
                return this.items.find(item => item.makroId === this.currentHallId)
            }
        },
        methods: {
            /**
             * Get all Halls from api to feed list and current hall
             */
            async getHallsFromApi () {
                this.loading = true
                this.error = false
                return ApiMakro.getHalls().then(response => {
                    this.items = response.data
                    const defaultHall = this.items.find(item => item.makroId === '1')

                    if (defaultHall) {
                        this.onSelect(defaultHall)
                    } else if (this.items[0]) {
                        this.onSelect( this.items[0])
                    }

                    this.findNearestHall()
                }).catch(() => {
                    this.error = true
                }).finally(() => {
                    this.loading = false
                })
            },
            /**
             * Select hall from list
             *
             * @param {object} item
             */
            onSelect (item) {
                console.log('item selected', item)
                this.currentHallId = item.makroId
                this.$emit('input', this.currentHallId)
            },
            open () {
                if (!this.disabled) {
                    this.$refs.halls.open()
                }
            },
            findNearestHall () {
                if (!navigator.geolocation) {
                    return
                }
                console.log('find nearest hall')

                navigator.geolocation.getCurrentPosition(position => {
                    console.log('position ', position.coords)

                    let sortedByDistance = this.items.map(item => {
                        if (!item.latitude || !item.longitude) {
                            item.distanceLatLon = 89
                            return item
                        }

                        let latDiff = Math.pow(parseFloat(item.latitude) - position.coords.latitude, 2),
                            lonDiff = Math.pow(parseFloat(item.longitude) -  position.coords.longitude, 2)

                        item.distanceLatLon = Math.sqrt(latDiff + lonDiff)
                        return item
                    }).sort((a, b) => a.distanceLatLon - b.distanceLatLon)

                    if (sortedByDistance && sortedByDistance.length > 0) {
                        this.onSelect( sortedByDistance[0])
                    }

                });
            }
        }
    }
</script>

<style lang="scss">
.form-hall {
    @import 'src/assets/scss/_variables/color';
    @import 'src/assets/scss/_variables/mixin';
    @import 'src/assets/scss/_variables/fonts';

    margin-bottom: 34px;
    background-color: #f4f4f4;
    border: 2px solid $color-positive;
    border-radius: 4px;
    padding: 27px 24px 27px 40px;
    position: relative;
    font-size: 1.7rem;
    line-height: 21 / 17;

    &.invalid {
        border-color: $color-error;
    }

    &-name {
        font-size: 2rem;
        font-weight: $font-weight-bold;
    }

    &-current {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &-button {
        height: 32px;
        // border: 2px solid $color-positive;
        white-space: nowrap;
        border: 0;
        outline: none;
        border-radius: 32px;
        padding: 0 1em;
        display: inline-block;
        position: relative;
        cursor: pointer;
        transition: .2s;
        vertical-align: top;
        font-size: 14px;
        line-height: 1;
        color: #fff;
        background-color: $color-positive;
        margin-left: 10px;

        &:disabled {
            opacity: .8;
            cursor: default;
        }

        &:after {
            position: relative;
            display: inline-block;
            content: '';
            border-top: white solid 2px;
            border-right: white solid 2px;
            transform: rotate(45deg);
            top: -2px;
            margin: 0 -2px 0 5px;
            @include size(4px);
        }

        &:hover:not(:disabled) {
            background-color: $color-positive-lite;
        }
    }
}
</style>
